import { clearSelection } from "../utils/selection.js";
import { addEvt, cleanEvt, prevent, listenOpts } from "../utils/event.js";
import { getElement } from "../utils/dom.js";
import { isKeyCode } from "../utils/key-composition.js";
export default {
  props: {
    target: {
      default: true
    },
    noParentEvent: Boolean,
    contextMenu: Boolean
  },
  watch: {
    contextMenu: function contextMenu(val) {
      if (this.anchorEl !== void 0) {
        this.__unconfigureAnchorEl();

        this.__configureAnchorEl(val);
      }
    },
    target: function target() {
      if (this.anchorEl !== void 0) {
        this.__unconfigureAnchorEl();
      }

      this.__pickAnchorEl();
    },
    noParentEvent: function noParentEvent(val) {
      if (this.anchorEl !== void 0) {
        if (val === true) {
          this.__unconfigureAnchorEl();
        } else {
          this.__configureAnchorEl();
        }
      }
    }
  },
  methods: {
    __showCondition: function __showCondition(evt) {
      // abort with no parent configured or on multi-touch
      if (this.anchorEl === void 0) {
        return false;
      }

      if (evt === void 0) {
        return true;
      }

      return evt.touches === void 0 || evt.touches.length <= 1;
    },
    __contextClick: function __contextClick(evt) {
      var _this = this;

      this.hide(evt);
      this.$nextTick(function () {
        _this.show(evt);
      });
      prevent(evt);
    },
    __toggleKey: function __toggleKey(evt) {
      isKeyCode(evt, 13) === true && this.toggle(evt);
    },
    __mobileCleanup: function __mobileCleanup(evt) {
      this.anchorEl.classList.remove('non-selectable');
      clearTimeout(this.touchTimer);

      if (this.showing === true && evt !== void 0) {
        clearSelection();
      }
    },
    __mobilePrevent: prevent,
    __mobileTouch: function __mobileTouch(evt) {
      var _this2 = this;

      this.__mobileCleanup(evt);

      if (this.__showCondition(evt) !== true) {
        return;
      }

      this.hide(evt);
      this.anchorEl.classList.add('non-selectable');
      var target = evt.target;
      addEvt(this, 'anchor', [[target, 'touchmove', '__mobileCleanup', 'passive'], [target, 'touchend', '__mobileCleanup', 'passive'], [target, 'touchcancel', '__mobileCleanup', 'passive'], [this.anchorEl, 'contextmenu', '__mobilePrevent', 'notPassive']]);
      this.touchTimer = setTimeout(function () {
        _this2.show(evt);
      }, 300);
    },
    __unconfigureAnchorEl: function __unconfigureAnchorEl() {
      cleanEvt(this, 'anchor');
    },
    __configureAnchorEl: function __configureAnchorEl() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.contextMenu;

      if (this.noParentEvent === true || this.anchorEl === void 0) {
        return;
      }

      var evts;

      if (context === true) {
        if (this.$q.platform.is.mobile === true) {
          evts = [[this.anchorEl, 'touchstart', '__mobileTouch', 'passive']];
        } else {
          evts = [[this.anchorEl, 'click', 'hide', 'passive'], [this.anchorEl, 'contextmenu', '__contextClick', 'notPassive']];
        }
      } else {
        evts = [[this.anchorEl, 'click', 'toggle', 'passive'], [this.anchorEl, 'keyup', '__toggleKey', 'passive']];
      }

      addEvt(this, 'anchor', evts);
    },
    __setAnchorEl: function __setAnchorEl(el) {
      this.anchorEl = el;

      while (this.anchorEl.classList.contains('q-anchor--skip')) {
        this.anchorEl = this.anchorEl.parentNode;
      }

      this.__configureAnchorEl();
    },
    __pickAnchorEl: function __pickAnchorEl() {
      if (this.target === false || this.target === '') {
        this.anchorEl = void 0;
      } else if (this.target === true) {
        this.__setAnchorEl(this.parentEl);
      } else {
        this.anchorEl = getElement(this.target) || void 0;

        if (this.anchorEl !== void 0) {
          this.__configureAnchorEl();
        } else {
          console.error("Anchor: target \"".concat(this.target, "\" not found"), this);
        }
      }
    },
    __changeScrollEvent: function __changeScrollEvent(scrollTarget, fn) {
      var fnProp = "".concat(fn !== void 0 ? 'add' : 'remove', "EventListener");
      var fnHandler = fn !== void 0 ? fn : this.__scrollFn;

      if (scrollTarget !== window) {
        scrollTarget[fnProp]('scroll', fnHandler, listenOpts.passive);
      }

      window[fnProp]('scroll', fnHandler, listenOpts.passive);
      this.__scrollFn = fn;
    }
  },
  created: function created() {
    var _this3 = this;

    if (typeof this.__configureScrollTarget === 'function' && typeof this.__unconfigureScrollTarget === 'function') {
      this.noParentEventWatcher = this.$watch('noParentEvent', function () {
        if (_this3.__scrollTarget !== void 0) {
          _this3.__unconfigureScrollTarget();

          _this3.__configureScrollTarget();
        }
      });
    }
  },
  mounted: function mounted() {
    this.parentEl = this.$el.parentNode;

    this.__pickAnchorEl();

    if (this.value === true && this.anchorEl === void 0) {
      this.$emit('input', false);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.touchTimer);
    this.noParentEventWatcher !== void 0 && this.noParentEventWatcher();
    this.__anchorCleanup !== void 0 && this.__anchorCleanup();

    this.__unconfigureAnchorEl();
  }
};